import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {TitleStyle, TableHeaderColumnStyle, TableColumnWidth, TableColumnAlignment} from './Table.styled';
import {LayoutContext} from './table';
import {SortingIndicator} from '../sorting-indicator';

export const TableHeaderColumn = ({
	children,
	visible,
	width,
	groupingWhiteSpace,
	align,
	sortId,
	level,
	firstColumn,
	wrapped,
	usePadding = true,
	wrapText = false,
}) => {
	const layoutContext = useContext(LayoutContext);
	if (!visible) {
		return null;
	}
	const handleClick = () => {
		if (sortId) {
			layoutContext.onSort(sortId);
		}
	};

	const sorted = layoutContext.sort.id === sortId;

	return (
		<TableHeaderColumnStyle
			wrapped={wrapped}
			firstColumn={firstColumn}
			level={level}
			sortable={sortId}
			sorted={sorted}
			onClick={handleClick}
			width={width}
			groupingWhiteSpace={groupingWhiteSpace}
			wrapText={wrapText}
			align={align}
			usePadding={usePadding}
		>
			{children}
			{!!sortId && (
				<div style={{marginLeft: '4px'}}>
					<SortingIndicator sorted={sorted} direction={layoutContext.sort.direction} />
				</div>
			)}
		</TableHeaderColumnStyle>
	);
};

TableHeaderColumn.propTypes = {
	children: PropTypes.any,
	visible: PropTypes.bool,
	width: PropTypes.oneOf(Object.values(TableColumnWidth)),
	align: PropTypes.oneOf(Object.values(TableColumnAlignment)),
	groupingWhiteSpace: PropTypes.bool,
	sortId: PropTypes.string,
	firstColumn: PropTypes.bool,
	wrapped: PropTypes.bool,
	level: PropTypes.number,
	flex: PropTypes.number,
	usePadding: PropTypes.bool,
	wrapText: PropTypes.bool,
};

export const TableHeaderTitle = ({usePadding, children, bold}) => {
	return (
		<TitleStyle usePadding={usePadding} bold={bold}>
			{children}
		</TitleStyle>
	);
};

TableHeaderTitle.propTypes = {
	children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string, PropTypes.number])
		.isRequired,
	usePadding: PropTypes.bool,
	bold: PropTypes.bool,
};
